import FinalizeSingleMatch from "./general/finalize-single-match";
import FinalizeDoubleMatch from "./general/finalize-double-match";
import Single from "../../tennis/rules/general/scoring/single";
import Double from "../../tennis/rules/general/scoring/double";
import SingleScoring from "./general/scoring/singleScoring";
import DoubleScoring from "./general/scoring/doubleScoring";
import FinalizeEvent from "./general/finalize-event";

const TennisRules = Object.freeze({
    General: Object.freeze({
        FinalizedMatch: Object.freeze({
            Single: new FinalizeSingleMatch(),
            Double: new FinalizeDoubleMatch()
        }),
        Scoring: Object.freeze({
            Single: new Single(),
            Double: new Double(),
            SingleScoring: new SingleScoring(),
            DoubleScoring: new DoubleScoring()
        }),
        FinalizeEvent: new FinalizeEvent()
    })
});

export default TennisRules;
